"use client";
import ArrowRightSvg from "../../../../svgs/ArrowRightSVG";
import MoriButton from "../../../systemDesign/Buttons/MoriButton";
import Laptop from "../../../../pngs/Laptop.png";
import HeroSectionLinear from "../../../../pngs/HeroSectionLinear.png";
import HeroSectionLinear2 from "../../../../pngs/HeroSectionLinear2.png";
import HeroSectionLinear3 from "../../../../pngs/HeroSectionLinear3.png";
import HeroSectionBgSVG from "../../../../svgs/HeroSectionBgSVG";

const LandingPageHeader = () => {
  return (
    <div className="w-full flex gap-[19px] md:gap-6 flex-col mt-40 items-center text-center relative">
      <div className="w-full [&>*]:w-full [&>*]:h-full absolute right-0 bottom-[100px] flex justify-center items-center">
        <HeroSectionBgSVG />
        <img
          src={HeroSectionLinear2}
          alt=""
          className="!w-[53%] !h-[66%] absolute left-0 top-0 brightness-[15%]"
        />
        <img
          src={HeroSectionLinear3}
          alt=""
          className="w-full h-full absolute left-0 -top-20 brightness-[15%]"
        />
        <img
          src={HeroSectionLinear}
          alt=""
          className="w-full h-full absolute left-0 -top-10"
        />
      </div>
      <h1 className="text-[20px] min-[550px]:text-[30px] md:text-[48px] text-white">
        Artificial intelligence of Iranian lawyers
      </h1>
      <p className="max-w-[674px] leading-[26px] text-text2 text-[10px] min-[550px]:text-[15px] md:text-[20px] z-40">
        The first global legal artificial intelligence based on documented and
        reasoned answers based on 100% of specialized legal resources of the
        Islamic Republic of Iran
      </p>
      <div className="flex mt-2 items-center gap-6">
        <MoriButton
          text="Start Robot"
          textCustomClass="!text-[14px] !text-secondary1"
          customClass="!bg-primary3 border-[1px] border-stroke1 !w-[160px] md:!w-[181px] !h-[48px] !rounded-full cursor-pointer"
        />
        <MoriButton
          text="About Chatbot"
          textCustomClass="!text-text3 !text-[14px]"
          customClass="!w-[160px] md:!w-[181px] !flex-row-reverse !gap-[5px] !items-center !bg-transparent !h-[48px] cursor-pointer"
          icon={<ArrowRightSvg width={22} />}
        />
      </div>
      <div>
        <img
          src={Laptop}
          alt="Laptop"
          className="mt-8  md:w-[700px] lg:w-[924px] relative z-10"
        />
      </div>
      <div className="w-full h-[250px] md:h-[400px]  absolute bottom-0 z-20 bg-gradient-to-t from-primary1 to-transparent"></div>
    </div>
  );
};

export default LandingPageHeader;
